<div id="component-ys-inner-{{ component.id }}" class="ql-editor" [innerHtml]="htmlString" (mousedown)="onMouseDown()"
  (mouseup)="onMouseUp()" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"></div>